






















import { Component, Mixins, VModel } from 'vue-property-decorator'

import { UseFields } from '../../../../../components/Pi'
import { FieldData } from '../../../../../components/Pi/types'
import PeriodSimplifier from '../../../../PeriodSimplifier/PeriodSimplifier.vue'
import { StepUnit } from '../../../../PeriodSimplifier/types'
import FlowHelper from '../../logic/Helpers/helper'
import { SocketNames } from '../Socket/SocketsHelper'

@Component({
  components: {
    PeriodSimplifier,
  },
  data() {
    return {
      FlowHelper,
      SocketNames,
      StepUnit,
    }
  }
})
export default class InactiveInput extends Mixins(UseFields) {
  @VModel() time!: number

  inactiveInputChange(arg: FieldData): FieldData {
    arg.setter = (val) => this.time = val

    return arg
  }
}
